module.exports = __webpack_public_path__ + "img/VivaEdit.3ad5685a.png";